import React, {useState, useRef} from "react";
import {
	ScrollView,
	View,
	Animated,
	StyleSheet
} from "react-native";

import Style from "ae-style";

const ScrollIndicator = ({children, style, innerIndicatorStyle, outerIndicatorStyle}) => {
	const [wholeHeight, setWholeHeight] = useState(1);
	const [visibleHeight, setVisibleHeight] = useState(0);
	const scrollIndicator = useRef(new Animated.Value(0)).current;

	const indicatorSize = wholeHeight > visibleHeight ? (visibleHeight * (visibleHeight - 10)) / wholeHeight : visibleHeight;
	const difference = visibleHeight > indicatorSize ? visibleHeight - indicatorSize : 1;

	const scrollIndicatorPosition = Animated.multiply(
		scrollIndicator,
		visibleHeight / wholeHeight
	).interpolate({
		inputRange: [0, difference],
		outputRange: [0, difference],
		extrapolate: "clamp"
	});

	return (
		<View style={styles.container}>
			<ScrollView
				contentContainerStyle={{paddingRight: 14}}
				style={style}
				showsVerticalScrollIndicator={false}
				onContentSizeChange={(_, contentHeight) => {setWholeHeight(contentHeight)}}
				onLayout={({nativeEvent: {layout: {height}}}) => {setVisibleHeight(height)}}
				scrollEventThrottle={16}
				onScroll={Animated.event([{nativeEvent: {contentOffset: {y: scrollIndicator}}}], {useNativeDriver: false})}
			>
				{children}
			</ScrollView>
			{wholeHeight !== visibleHeight && <View style={[styles.outerIndicator, outerIndicatorStyle]}>
				<Animated.View 
					style={[styles.innerIndicator, {
						height: indicatorSize,
						transform: [{
							// TODO: Fix this
							translateY: isNaN(scrollIndicatorPosition) ? 0 : scrollIndicatorPosition
						}]
					}, innerIndicatorStyle]}
				/>
			</View>}
		</View>
	)
};

const styles = StyleSheet.create({
	container: {
		flexDirection: "row",
		marginRight: 2,
		marginTop: 2,
		marginBottom: 2
	},
	outerIndicator: {
		height: "100%", 
		width: 6,
		borderRadius: 8
	},
	innerIndicator: {
		borderRadius: 8,
		width: 6,
		backgroundColor: Style.colors.primary
	}
})

export default ScrollIndicator;